import {useMediaQuery} from "react-responsive";

export interface MediaProp {
    isTabletOrMobile?: boolean;
    isPortrait?: boolean;
    mobile?: boolean;
}

export namespace MediaProp {
  export function Query(): MediaProp {

    const isTabletOrMobile = useMediaQuery({query: '(max-width: 1224px)'})
    const isPortrait = useMediaQuery({query: '(orientation: portrait)'})

    const mobile: boolean = isTabletOrMobile || isPortrait;

    return { isTabletOrMobile, isPortrait, mobile };
  }
}